export interface ImportingFolderTreeStatus {
  name: string;
  stage: ImportingFolderTreeStage;
  folderId?: string;
}

export enum ImportingFolderTreeStage {
  Zipping = 'Zipping',
  SendingToServer = 'SendingToServer',
  Completed = 'Completed',
  Error = 'Error',
}
